import { render, staticRenderFns } from "./ShipPaging.vue?vue&type=template&id=73a49722&scoped=true&"
import script from "./ShipPaging.vue?vue&type=script&lang=js&"
export * from "./ShipPaging.vue?vue&type=script&lang=js&"
import style0 from "./ShipPaging.vue?vue&type=style&index=0&id=73a49722&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a49722",
  null
  
)

export default component.exports